import { render, staticRenderFns } from "./AppointmentWidget.vue?vue&type=template&id=2c4d22d4&scoped=true&"
import script from "./AppointmentWidget.vue?vue&type=script&lang=ts&"
export * from "./AppointmentWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentWidget.vue?vue&type=style&index=0&id=2c4d22d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d22d4",
  null
  
)

export default component.exports